

import "./loader.scss";

export default function Loader({ className }: { className: string }) {
  return (
    <section className={`loader-wrapper ${className}`}>
      <div className="loader"></div>
    </section>
  );
}
